import React from 'react';
import {create, InstanceProps} from 'react-modal-promise';

import {ModalReact, ModalType} from 'common/components/modal';
import {ModalChangeEvent} from 'common/components/modal/types';

import styles from './index.module.styl';

interface ImageModalProps {
  imageUrl: string;
  onClose: () => void;
}

function ImageModalContent({imageUrl, onClose}: ImageModalProps) {
  const handleModalChange = (ev: ModalChangeEvent) => {
    if (ev.detail.state === `closed`) {
      onClose();
    }
  };

  return (
    <ModalReact
      className={`image-modal`} // add as a selector for prevent-close-selectors, not for styling
      modalType={ModalType.Modal}
      open
      // @ts-ignore-strict: ModalReact onChange is not typed correctly
      onChange={handleModalChange}
      closeable
      growToContent
      ignoreStacking
      style-override={`
        .mp-modal-close-button {
          right: 5px !important;
          top: 5px !important;
        }
      `}
    >
      <div className={styles.imageModalContent}>
        <img className={styles.modalImage} src={imageUrl} />
      </div>
    </ModalReact>
  );
}

// Wrapper component for react-modal-promise
function ImageModal(props: {imageUrl: string} & InstanceProps<void>) {
  const {onResolve, imageUrl} = props;

  return <ImageModalContent imageUrl={imageUrl} onClose={() => onResolve()} />;
}

export const openImageModal = create(ImageModal);
